import React from 'react';
import { Heart } from 'lucide-react';
import { motion } from 'framer-motion';
import { useApp, MOCK_PRODUCTS } from '../context/AppContext';
import { Header } from '../components/ui/Header';
import { ProductCard } from '../components/ui/ProductCard';
export function WishlistScreen() {
  const {
    wishlist
  } = useApp();
  const wishlistedProducts = MOCK_PRODUCTS.filter(p => wishlist.includes(p.id));
  return <motion.div initial={{
    opacity: 0,
    x: 20
  }} animate={{
    opacity: 1,
    x: 0
  }} className="min-h-screen bg-gray-50" data-id="element-2715">
      <Header title="My Wishlist" data-id="element-2716" />

      <div className="p-4" data-id="element-2717">
        {wishlistedProducts.length > 0 ? <div className="grid grid-cols-2 gap-4" data-id="element-2718">
            {wishlistedProducts.map(product => <ProductCard key={product.id} product={product} data-id="element-2719" />)}
          </div> : <div className="py-20 flex flex-col items-center justify-center text-center" data-id="element-2720">
            <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mb-4 text-gray-300" data-id="element-2721">
              <Heart className="w-10 h-10" data-id="element-2722" />
            </div>
            <h2 className="text-xl font-bold text-gray-900 mb-2" data-id="element-2723">
              Your wishlist is empty
            </h2>
            <p className="text-gray-500" data-id="element-2724">
              Tap the heart icon on any product to save it here.
            </p>
          </div>}
      </div>
    </motion.div>;
}